<form [formGroup]="searchForm" class="d-flex">
  <mat-form-field class="search-box no-bottom-padding">
    <mat-label>Search {{ dashboardName }}</mat-label>
    <input matInput formControlName="keyword" #keywordInput />
    <mat-icon *ngIf="!isSubmitted" matSuffix (click)="submit()"
      >search</mat-icon
    >
    <mat-icon *ngIf="isSubmitted" matSuffix (click)="clear()">close</mat-icon>
  </mat-form-field>
</form>
